/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UsdcPurchaseBuyerNotificationActionData } from './UsdcPurchaseBuyerNotificationActionData';
import {
    UsdcPurchaseBuyerNotificationActionDataFromJSON,
    UsdcPurchaseBuyerNotificationActionDataFromJSONTyped,
    UsdcPurchaseBuyerNotificationActionDataToJSON,
} from './UsdcPurchaseBuyerNotificationActionData';

/**
 * 
 * @export
 * @interface UsdcPurchaseBuyerNotificationAction
 */
export interface UsdcPurchaseBuyerNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof UsdcPurchaseBuyerNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof UsdcPurchaseBuyerNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof UsdcPurchaseBuyerNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {UsdcPurchaseBuyerNotificationActionData}
     * @memberof UsdcPurchaseBuyerNotificationAction
     */
    data: UsdcPurchaseBuyerNotificationActionData;
}

/**
 * Check if a given object implements the UsdcPurchaseBuyerNotificationAction interface.
 */
export function instanceOfUsdcPurchaseBuyerNotificationAction(value: object): value is UsdcPurchaseBuyerNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function UsdcPurchaseBuyerNotificationActionFromJSON(json: any): UsdcPurchaseBuyerNotificationAction {
    return UsdcPurchaseBuyerNotificationActionFromJSONTyped(json, false);
}

export function UsdcPurchaseBuyerNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsdcPurchaseBuyerNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': UsdcPurchaseBuyerNotificationActionDataFromJSON(json['data']),
    };
}

export function UsdcPurchaseBuyerNotificationActionToJSON(value?: UsdcPurchaseBuyerNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': UsdcPurchaseBuyerNotificationActionDataToJSON(value.data),
    };
}

